import React, { Component } from 'react';
// import logo from './icon.png';
// import store from './store.png';
import './App.css';
import 'react-dropdown/style.css';
import { AwesomeButton } from "react-awesome-button";
import "react-awesome-button/dist/styles.css";
import { CoolCardLink, CoolCardImage, CoolCardText } from "react-cool-card";
import * as EmailValidator from 'email-validator';

import api from './utils/api';
import isLocalHost from './utils/isLocalHost';

class App extends Component {
  constructor() {
    super()
    this.state = {
      countrys: [],
      choose: '',
      coupons: [],
      acoupons: [],
      coupon: null,
      copied: false,
      datas: [],
      loader: true,
      note: '',
      featured: [],
      output: '',
      product: '',
      productlink: '',
      productnumber: ''
    }
  }

  componentDidMount() {
    this.init();

  }

  init() {
    api.readParams().then((result) => {
      // console.log(result);

      this.setState({
        product: result.name,
        productlink: `https://galaxy.store/abc${result.number}`,
        productnumber: result.number,
      }, () => {

      });

    });

    api.readAllCountry().then((result) => {
      // console.log("readAllCountry");

      if (result.message === 'unauthorized') {
        if (isLocalHost()) {
          alert('FaunaDB key is not unauthorized. Make sure you set it in terminal session where you ran `npm start`. Visit http://bit.ly/set-fauna-key for more info');
        } else {
          alert('FaunaDB key is not unauthorized. Verify the key `FAUNADB_SERVER_SECRET` set in Netlify enviroment variables is correct');
        }
        return false
      }

      if (result && result.length) {
        const country = [...new Set(result.map(x => x.data.Country))];

        this.setState({
          countrys: country,
          loader: false,
        });
      }

    });

    api.readAllFeatured().then((result) => {
      // console.log("readAllFeatured");

      if (result.message === 'unauthorized') {
        if (isLocalHost()) {
          alert('FaunaDB key is not unauthorized. Make sure you set it in terminal session where you ran `npm start`. Visit http://bit.ly/set-fauna-key for more info');
        } else {
          alert('FaunaDB key is not unauthorized. Verify the key `FAUNADB_SERVER_SECRET` set in Netlify enviroment variables is correct');
        }
        return false
      }

      let output = [];

      function logMapElements(value, key, map) {
        let dummy =
          <div key={`link${value.data.order}`} style={{ padding: 10 }}>
            <CoolCardLink href={value.data.href} width='250px' height='200px' backgroundColor='#cccccc' fontSize='0.7rem' >
              <CoolCardImage src={value.data.image} alt={value.data.imagealt} />
              <CoolCardText
                title={value.data.title}
                description={value.data.description}
              />
            </CoolCardLink>
          </div>
          ;

        output.push(dummy);
      }

      if (result && result.length) {
        result.forEach(logMapElements);

        this.setState({
          featured: result,
          output: output,
        });
      }

    });


  }

  onSelect = (item) => {
    this.setState({
      choose: item.value,
      note: '',
      loader: true,
    });

    let parent = this;

    let filtered = [];
    let afiltered = [];

    api.readAllCouponStatus({
      'Country': item.value,
      'Coupon Status': 'Not Used',
    }).then((result) => {
      if (result.message === 'unauthorized') {
        if (isLocalHost()) {
          alert('FaunaDB key is not unauthorized. Make sure you set it in terminal session where you ran `npm start`. Visit http://bit.ly/set-fauna-key for more info');
        } else {
          alert('FaunaDB key is not unauthorized. Verify the key `FAUNADB_SERVER_SECRET` set in Netlify enviroment variables is correct');
        }
        return false
      }

      parent.setState({
        datas: result,
        loader: false,
      });

      if (parent.state.datas.length > 0) {
        filtered = parent.state.datas;

        afiltered = parent.state.datas;

      } else {
      }

      parent.setState({
        coupons: filtered,
        acoupons: afiltered,
        coupon: afiltered[Math.floor(Math.random() * afiltered.length)],
        copied: false,
      });

    });

  }

  sendEmail = () => {
    this.setState({
      copied: true,
      loader: true
    });

    let email = document.getElementById("useremail").value;

    var templateParams = {
      "customer": email,
      "subject": `Free Coupons - ${this.state.product} - ${this.state.coupon.data['Country']}`,
      "product": this.state.product,
      "country": this.state.coupon.data['Country'],
      "coupon": this.state.coupon.data['Coupon Code'],
      "expired": this.state.coupon.data['Expiration Date(GMT)'],
      "link": this.state.productlink,
    };

    // console.log('templateParams', templateParams);

    let parent = this;

    if (EmailValidator.validate(email)) {
      api.aliyun(templateParams)
        .then((result) => {
          // console.log('result', result);

          if (result.statusCode === 400) {
            parent.setState({ loader: false, note: 'Failed...' });

          } else {
            parent.setState({ loader: false, note: 'Success' });

            let myid = parent.state.coupon.ref['@ref'].id;

            // console.log(myid);

            api.update(myid, {
              'Coupon Status': 'Used',
              'Email': email,
            }).then(() => {
              console.log(`update todo ${myid}`, email)
            }).catch((e) => {
              console.log('An API error occurred', e)
            });

          }

        }).catch((error) => {
          console.log('error', error);

          parent.setState({ loader: false, note: 'Failed...' });

        });

    } else {
      parent.setState({ loader: false, note: 'Failed...' });

    }

  }

  render() {
    // console.log('elements', this.state.data ? this.state.data.Sheet2 ? this.state.data.Sheet2.elements : null : null);
    // console.log('countrys', this.state.countrys ? this.state.countrys : null);
    // console.log('coupons', this.state.coupons ? this.state.coupons : null);
    // console.log('coupon', this.state.coupon ? this.state.coupon : null);
    // console.log('choose', this.state.choose ? this.state.choose : null);
    // console.log('loader', this.state.loader ? this.state.loader : null);
    // console.log('featured', this.state.featured ? this.state.featured : null);
    // console.log('output', this.state.output ? this.state.output : null);

    return (
      <div className="App">
        <header className="App-header" style={{ paddingLeft: 10, paddingRight: 10 }}>
          <p>ABC Watchface Coupons Generator</p>

            <p>
              <AwesomeButton type="instagram" href="https://instagram.com/abcwatchface" target="_blank" >ABC Watchface Instagram</AwesomeButton>
              <br /><br />
              <AwesomeButton type="facebook" href="https://facebook.com/abcwatchface" target="_blank" >Facebook Coupons Page</AwesomeButton>
              <br /><br />
              <AwesomeButton type="link" href="https://t.me/abcstudioid" target="_blank" >Telegram Coupons Channel</AwesomeButton>
              <br /><br />
              <AwesomeButton type="twitter" href="https://www.abcwatchface.com" target="_blank" >ABC Watchface Website</AwesomeButton>
            </p>

        </header>

        <header className="App-header" style={{ paddingLeft: 10, paddingRight: 10, backgroundColor: 'transparent' }}>
          <p style={{ color: 'black' }}>Featured Watchface</p>

          {this.state.output}
        </header>

      </div>
    );
  }
}

export default App;
